export const orgNumberStyle = {
    fontSize: "1.3rem",
    border: "blue",
    borderStyle: "solid",
    padding: "10px",
    width: "100%",
    textAlign: "center"
};

export const imageContainer = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around"
};

export const homeImg = {
    width: "45%",
    height: "400px",
    border: "solid 1px",
    minWidth: "400px",
    maxWidth: "100%",
    maxHeight: "auto"
};

export const imgPadding = {
    padding: "10px"
};

export const blueHeading = {
    color: "blue"
};

export const alignLeft = {
    textAlign: "left"
};

export const secondRow = {
    width: "100%",
    display: "flex"
};

export const textContainer = {
    width: "50%",
    paddingLeft: "30px"
};

export const orgNumberSignIn = {
    width: "50%"
};

export const text = {
    fontSize: "1.3rem",
    paddingRight: "30px"
};

export const pricesRow = {
    display: "flex",
    justifyContent: "space-around"
};

export const cardsPadding = {
    padding: "10px"
};

export const cardTitle = {
    backgroundColor: "darkblue",
    color: "white",
    padding: "20px"
};

export const card = {
    width: "18rem",
    margin: "0",
    float: "none",
    color: "black",
    textAlign: "center"
};

export const mxAuto = {
    fontSize: "1.3rem",
    color: "white"
};
